import type { IncidentSummary } from '@ftthnms/shared';
import { useQuery } from '@tanstack/react-query';
import { api, qs } from './api';
import { useSession } from './session';

/** Open/acknowledged counts for the sidebar badge and topbar bell (refreshed by realtime events). */
export function useIncidentSummary() {
  const { area, ability } = useSession();
  return useQuery({
    queryKey: ['incidents', 'summary', area],
    queryFn: () => api<IncidentSummary>(`/api/v1/incidents/summary${qs({ area })}`),
    enabled: ability.can('read', 'Alert'),
    refetchInterval: 120_000,
  });
}
